import GeneratedMailAliasServiceApi from "./generated/GeneratedMailAliasServiceApi"

class MailAliasServiceApi extends GeneratedMailAliasServiceApi {

}

export const mailAliasServiceApi = new MailAliasServiceApi()
